import React from 'react';

class BusinessTypesDescriptionFormatter extends React.Component {
	shouldComponentUpdate(nextProps) {
		return nextProps.value !== this.props.value;
	}

	render() {
		const row = this.props.dependentValues;

		// Special rows - add gray background
		if (row.isSpecialRow) {
			const bgColor = row.certificationStatusDescription === "Prequals" ? "#f0f0f0" : "#e0e0e0";
			return (
				<div style={{ backgroundColor: bgColor, marginLeft: "-8px", paddingLeft: "16px", marginRight: "-8px", height: "35px", lineHeight: "35px" }}>
					{this.props.value}
				</div>
			);
		}

		return <span style={{ paddingLeft: "8px" }}>{this.props.value}</span>;
	}
}

export default BusinessTypesDescriptionFormatter;



// WEBPACK FOOTER //
// ./src/areas/shared/components/formatter/BusinessTypesDescriptionFormatter.js